import { useEffect, useRef, useState } from "react";

// Velocidade CONSTANTE do marquee (px por segundo), compartilhada por toda a
// barra lateral: pílula de filtro e rótulos das árvores (ativos e recursos).
// Ajustar aqui muda o ritmo em TODOS os lugares de uma vez, mantendo a
// consistência entre as páginas.
export const MARQUEE_SPEED_PX_PER_S = 60;

/**
 * Detecta overflow horizontal de um texto e calcula o deslocamento/duração de
 * um marquee de velocidade constante que rola só até expor a cauda escondida e
 * para (a animação em si vive no CSS, via as vars --marquee-shift/-duration).
 *
 * @param {*} dep valor que, ao mudar, recalcula a medição (ex.: o label do nó).
 * @returns {{ outerRef, innerRef, marquee: { overflow, shift, dur }, marqueeVars }}
 */
export function useMarquee(dep) {
  const outerRef = useRef(null);
  const innerRef = useRef(null);
  const [marquee, setMarquee] = useState({ overflow: false, shift: 0, dur: 0 });

  useEffect(() => {
    const outer = outerRef.current;
    const inner = innerRef.current;
    /* istanbul ignore else -- refs sempre presentes após montar; ramo falso não ocorre */
    if (outer && inner) {
      const distance = inner.scrollWidth - outer.clientWidth;
      if (distance > 0) {
        setMarquee({
          overflow: true,
          shift: distance,
          dur: distance / MARQUEE_SPEED_PX_PER_S,
        });
      } else {
        setMarquee({ overflow: false, shift: 0, dur: 0 });
      }
    }
  }, [dep]);

  const marqueeVars = {
    "--marquee-shift": `-${marquee.shift}px`,
    "--marquee-duration": `${marquee.dur}s`,
  };

  return { outerRef, innerRef, marquee, marqueeVars };
}
